import { useState, useMemo, useCallback } from 'react';
import { DateRange } from 'react-day-picker';

export interface StatistiquesFilters {
  customPeriod: DateRange | undefined;
  position: string;
  period: string;
}

export const useStatistiquesFilters = () => {
  const [customPeriod, setCustomPeriod] = useState<DateRange | undefined>(undefined);
  const [position, setPosition] = useState<string>('all');
  const [period, setPeriod] = useState<string>('7d');

  // Mémoriser l'objet filters pour éviter les re-renders inutiles
  const filters = useMemo<StatistiquesFilters>(() => ({
    customPeriod,
    position,
    period
  }), [customPeriod, position, period]);

  const updateCustomPeriod = useCallback((newPeriod: DateRange | undefined) => {
    setCustomPeriod(newPeriod);
  }, []);

  const updatePosition = useCallback((newPosition: string) => {
    setPosition(newPosition);
  }, []);

  const updatePeriod = useCallback((newPeriod: string) => {
    setPeriod(newPeriod);
  }, []);

  const resetFilters = useCallback(() => {
    setCustomPeriod(undefined);
    setPosition('all');
    setPeriod('7d');
  }, []);

  return {
    filters,
    updateCustomPeriod,
    updatePosition,
    updatePeriod,
    resetFilters
  };
};